import styled, { css } from 'styled-components';

import {
    mediaMixin,
    spaceMixin,
    Text,
} from '@zillow/constellation';

export const StyledFlexPriceOnlyContainer = styled.div`
    align-items: center;
    display: flex;
    flex-grow: 1;
    order: -1;

    ${mediaMixin('lg', css`
        justify-content: flex-end;
        order: 1;
        margin-right: ${spaceMixin('sm')};
    `)}
`;

export const StyledPriceTag = styled(Text)`
    && {
        font-weight: 700;
        font-size: 14px;

        ${mediaMixin('lg', css`
            font-size: 20px;
        `)}
    }
`;

export const StyledWeek = styled(Text)`
    && {
        font-size: 12px;

        ${mediaMixin('lg', css`
            font-size: 14px;
            line-height: 30px;
        `)}
    }
`;

export const StyledVerticalDivider = styled.div`
    background-color: #ccc;
    display: flex;
    height: 14px;
    margin: 0 ${spaceMixin('xs')};
    width: 1px;
`;

export const StyledMobileOnlyVerticalDivider = styled.div`
    background-color: #ccc;
    display: flex;
    height: 10px;
    margin: 0 ${spaceMixin('xs')};
    width: 1px;

    ${mediaMixin('lg', css`
        display: none;
    `)}
`;
